import {
  HttpErrorResponse,
  HttpHeaders,
  HttpStatusCode,
} from '@angular/common/http';

interface ErrorOptions {
  error?: any;
  headers?: HttpHeaders;
  url?: string;
}

export class HttpUtils {
  static createNotFound(options?: ErrorOptions) {
    return this.createErrorResponse(HttpStatusCode.NotFound, options);
  }

  static createBadRequest(options?: ErrorOptions) {
    return this.createErrorResponse(HttpStatusCode.BadRequest, options);
  }

  private static createErrorResponse(
    statusCode: number,
    options?: ErrorOptions
  ) {
    if (!options) {
      options = {};
    }
    return new HttpErrorResponse({
      error: options.error,
      headers: options.headers,
      url: options.url,
      status: statusCode,
      statusText: 'Unknown Error',
    });
  }
}
